import { Icon } from 'design-system/components/Icon';
import { Typography } from 'design-system/components/Typography';
import { EDataBlockCourseEmphasis, IDataBlockCourse } from './types';

const DataBlockCourse = (props: IDataBlockCourse) => {
  const {
    iconName,
    value,
    label,
    emphasis = 'High',
    className,
    endAdornment,
    labelClassName,
    ...restProps
  } = props;
  const isEmphasisHigh = emphasis === EDataBlockCourseEmphasis.High;
  const finalSizeIcon = isEmphasisHigh ? 24 : 16;
  const iconClassName = [
    !isEmphasisHigh &&
      'rounded-full border border-Primary/Border bg-Primary/BlueBG p-1',
  ].join(' ');
  const finalClassName = [
    `p-2 flex gap-2 items-center text-Primary/Main`,
    isEmphasisHigh &&
      'rounded-[10px] border border-solid border-Other/Outlinedborder-stroke shadow-elevator2 bg-Other/White',
    className,
  ].join(' ');

  return (
    <div {...restProps} className={finalClassName}>
      {iconName && (
        <Icon
          iconName={iconName}
          width={finalSizeIcon}
          height={finalSizeIcon}
          className={iconClassName}
        />
      )}
      <div className="flex-1">
        <Typography variant="display2.5">{value}</Typography>
        <Typography
          variant="body4"
          className={`text-Text/Darkbackground/Secondary ${labelClassName}`}
        >
          {label}
        </Typography>
      </div>
      {endAdornment}
    </div>
  );
};

export default DataBlockCourse;
